document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
    nav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      nav.classList.remove('is-open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }));
  }

  document.querySelectorAll('img').forEach(img => {
    img.addEventListener('error', () => {
      img.style.background = '#fffaf7';
      img.style.objectFit = 'contain';
      img.alt = img.alt || 'Doha Rose image';
    });
  });

  /*
   * Doha Rose newsletter:
   * 1) The visible form is Shopify's native customer/newsletter form, so the
   *    email is stored as a marketing subscriber in Shopify.
   * 2) Before that form submits, we also submit a hidden native Shopify
   *    contact form. Shopify routes contact-form mail to the store contact
   *    email configured in Admin, giving the Doha Rose team a signup notice.
   *
   * Automatic marketing emails for every newly published product are an
   * Admin-side Shopify Email / automation feature and cannot be created by a
   * theme ZIP. The theme keeps subscribers correctly tagged so that automation
   * can target them.
   */
  const newsletter = document.getElementById('DohaRoseNewsletterForm');
  const ownerNotice = document.getElementById('DohaRoseSubscriberOwnerNotice');

  if (newsletter && !newsletter.dataset.notifyBound) {
    newsletter.dataset.notifyBound = 'true';

    newsletter.addEventListener('submit', async (event) => {
      if (newsletter.dataset.finalSubmit === 'true') return;

      const emailInput = newsletter.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.checkValidity()) return;

      event.preventDefault();
      const email = emailInput.value.trim();

      if (ownerNotice) {
        const noticeEmail = document.getElementById('DohaRoseOwnerNoticeEmail');
        const noticeBody = document.getElementById('DohaRoseOwnerNoticeBody');
        if (noticeEmail) noticeEmail.value = email;
        if (noticeBody) noticeBody.value = `New Doha Rose newsletter subscription from ${email}. The subscriber has requested Doha Rose product updates and marketing emails.`;

        try {
          const response = await fetch(ownerNotice.action || window.location.pathname, {
            method: 'POST',
            credentials: 'same-origin',
            body: new FormData(ownerNotice),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) {
            console.warn('Doha Rose subscriber owner notification returned:', response.status);
          }
        } catch (error) {
          console.warn('Doha Rose subscriber owner notification could not be sent.', error);
        }
      }

      newsletter.dataset.finalSubmit = 'true';
      newsletter.submit();
    });
  }
});
